var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timetable"},[_c('TimeScale',{on:{"click":function($event){_vm.handleClick($event)}}}),_vm._v(" "),_c('div',{staticClass:"bookings"},_vm._l((_vm.bookings),function(booking){return _c('Booking',{key:booking.id,attrs:{"data":booking}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c3411f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeTable.vue
// module id = null
// module chunks = 